import React, {useState, useEffect} from 'react'
import Link from 'next/link'
import styled from "styled-components";

const Footer = styled.div`

  background: rgba(0,0,0,0.2);
`
export default props => {
    return (
        <Footer>
            Footer
        </Footer>
    )

}
